import {List} from 'immutable';

export function isList(list: unknown): list is List<unknown> {
  return List.isList(list);
}
